import { WKDA_LEAD_COOKIE } from '../constants';
import { useCookie } from './useCookies';
export function useGetWKDALeadCookie() {
  const {
    cookies
  } = useCookie();
  let wkdaLead = cookies[WKDA_LEAD_COOKIE];
  return wkdaLead === 'undefined' ? undefined : wkdaLead;
}